import BixButton from '$/components/global/bixButton';
import * as Bixby from '$/core';
import { AppState } from '$/store';
import { msalIframeLogin, msalLoginSuccess, msalStandAloneLogin } from '$/store/msal/actions';
import React from 'react';
import { connect } from 'react-redux';
import './index.scss';
import { CscpIntegrationService, LoggerService, MsalService } from '$/services';

export interface IMsalAuthenticationRequiredProps {
  dispatchOnMsalStandAloneLogin?: () => Promise<void>;
  dispatchOnMsalInIframeLogin?: () => Promise<void>;
  dispatchMsalLoginSuccess?: () => Promise<void>;
  isMsalAuthenticated: boolean;
  children?: React.ReactNode;
}

const MsalAuthenticationRequired: React.FC<IMsalAuthenticationRequiredProps> = props => {
  const { dispatchOnMsalStandAloneLogin, dispatchOnMsalInIframeLogin, dispatchMsalLoginSuccess, isMsalAuthenticated } =
    props;
  const isStandAlone = Bixby.Configuration.isStandAloneMode;
  const dynamicClickHandler = isStandAlone ? dispatchOnMsalStandAloneLogin : dispatchOnMsalInIframeLogin;
  const msalAccount = MsalService.getAccount();

  //If we have an account we consider msal authenticated and ready for token requests but only in non stand alone mode
  if (!isStandAlone && !isMsalAuthenticated && msalAccount && dispatchMsalLoginSuccess) {
    LoggerService.log(`MsalAuthenticationRequired: Dispatching msal login success, as race condition lost!`);
    dispatchMsalLoginSuccess();
  } else {
    LoggerService.log(
      `MsalAuthenticationRequired: Not doing anything as we are already authenticated or simply don't have an account. account truthy: ${!!msalAccount}`
    );
  }
  if (!isMsalAuthenticated) {
    return (
      <div className="authentication_required_container">
        <div className="message">
          <p>Authentication Required.</p>
          <BixButton useSmall onClick={dynamicClickHandler}>
            Login to Microsoft
          </BixButton>
        </div>
      </div>
    );
  } else {
    if (!isStandAlone) {
      //Remove inital request here once we know we've used it
      CscpIntegrationService.removeInitialRequestPath();
    }
    return <React.Fragment>{props.children}</React.Fragment>;
  }
};

const mapStateToProps = (state: AppState) => {
  return {
    isMsalAuthenticated: state.msalState.authenticated,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchOnMsalStandAloneLogin: () => dispatch(msalStandAloneLogin()),
  dispatchOnMsalInIframeLogin: () => dispatch(msalIframeLogin()),
  dispatchMsalLoginSuccess: () => dispatch(msalLoginSuccess()),
});

export default connect(mapStateToProps, mapDispatchToProps)(MsalAuthenticationRequired);
